import React, { memo } from "react";

function LoginLayoutOverlay({ justifyContent, content }) {
  return (
    <div
      className="login-wrapper"
      style={{
        justifyContent,
      }}
    >
      {content}
    </div>
  );
}

export default memo(LoginLayoutOverlay);
